import { atom } from 'jotai';

export type ExamEditTab = 'general' | 'languages' | 'questions' | 'publications';

export const examEditTabAtom = atom<ExamEditTab>('general');
export const examWizardStepAtom = atom<number>(0);
